export default {
  anonymousUser: {
    id: 'reviews_anonymous_customer',
    defaultMessage: 'An anonymous Backer',
  },
  verified: {
    id: 'product_review_display_verified',
    defaultMessage: 'Verified',
  },
  reviewInfo: {
    id: 'product_review_display_review_info',
    defaultMessage: 'Reviewed {reviewDate}, {country}.',
  },
  productDetailsItem: {
    id: 'product_reviews_product_details_item',
    defaultMessage: 'Item',
  },
  productDetailsCondition: {
    id: 'product_reviews_product_details_condition',
    defaultMessage: 'Condition',
  },
  productDetailsSeller: {
    id: 'product_reviews_product_details_seller',
    defaultMessage: 'Seller',
  },
  ecoGrade: {
    id: 'product_reviews_product_details_eco_grade',
    defaultMessage: 'Fair',
  },
  veryGoodGrade: {
    id: 'product_reviews_product_details_very_good_grade',
    defaultMessage: 'Good',
  },
  flawlessGrade: {
    id: 'product_reviews_product_details_flawless_grade',
    defaultMessage: 'Excellent',
  },
  premiumGrade: {
    id: 'product_reviews_product_details_premium_grade',
    defaultMessage: 'Premium',
  },
  ecoGradeDescription: {
    id: 'product_reviews_product_details_eco_grade_description',
    defaultMessage:
      'Signs of wear. The body may have a few visible scratches and dents. Items with screens may have light scratches.',
  },
  veryGoodGradeDescription: {
    id: 'product_reviews_product_details_very_good_grade_description',
    defaultMessage:
      'Light signs of wear. The body may have light micro-scratches. For items with screens, the screen will have no scratches.',
  },
  flawlessGradeDescription: {
    id: 'product_reviews_product_details_flawless_grade_description',
    defaultMessage:
      'Almost no signs of wear. The body may have very light micro-scratches. For items with screens, the screen will have no scratches.',
  },
  premiumGradeDescription: {
    id: 'product_reviews_product_details_premium_grade_description',
    defaultMessage:
      'Close to perfection. The body may have tiny micro-scratches. For items with screens, the screen will be flawless.',
  },
  purchaseDate: {
    id: 'product_reviews_product_details_purchase_date',
    defaultMessage: 'Purchased',
  },
  seeItem: {
    id: 'product_reviews_product_details_see_item',
    defaultMessage: 'See item',
  },
  moreDetails: {
    id: 'product_reviews_product_details_more',
    defaultMessage: 'More details',
  },
} as const
